import { useState } from 'react';

import InlineImageCarousel from './InlineImageCarousel';
import InlinePostImage from './InlinePostImage';

export default function ImageDisplay({
  groupId,
  pictures,
  previewMode,
  handleImageRemove,
  handleCaptionChange,
}) {
  const [internalPictures, setInternalPictures] = useState(pictures);

  const internalDelete = (groupId, pictureId) => {
    const updatedPictures = internalPictures.filter(pic => pic.pictureId !== pictureId);
    setInternalPictures(updatedPictures);
    handleImageRemove(groupId, pictureId);
  };

  if (internalPictures.length === 1) {
    const img = internalPictures[0];

    return (
      <InlinePostImage
        groupId={groupId}
        image={{
          image_id: img.image_id,
          picture_description: img.picture_description || '',
          pictureId: img.pictureId,
        }}
        previewMode={previewMode}
        onRemove={() => internalDelete(groupId, img.pictureId)}
        onCaptionChange={handleCaptionChange}
      />
    );
  }
  return (
    <InlineImageCarousel
      groupId={groupId}
      images={internalPictures}
      previewMode={previewMode}
      onRemoveImage={internalDelete}
      onCaptionChange={handleCaptionChange}
    />
  );
}